import { put } from "redux-saga/effects";
import { setFocusedEntity } from "../slice";
import { ClarkFocusedEntityType } from "../types";
import type { selectWidgets } from "legacy/actions/widgetActions";

export function* setFocusedEntitySaga(
  action: ReturnType<typeof selectWidgets>,
) {
  const { widgetIds, selectingMultiple } = action.payload;

  if (selectingMultiple || widgetIds.length > 1) {
    return;
  }

  if (widgetIds.length === 1) {
    const widgetId = widgetIds[0];

    yield put(
      setFocusedEntity({
        entityId: widgetId,
        entityType: ClarkFocusedEntityType.WIDGET,
      }),
    );
  } else if (widgetIds.length === 0) {
    yield put(
      setFocusedEntity({
        entityId: undefined,
        entityType: undefined,
      }),
    );
  }
}
